// extracted by mini-css-extract-plugin
module.exports = {"WelcomeBox":"WelcomeBox_WelcomeBox__1p8FF","MCastLogo":"WelcomeBox_MCastLogo__1iZCv","AppLogo":"WelcomeBox_AppLogo__1F1U6"};